module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/main_card_background.0d18962d.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/main_card_background.jpg
// module id = 3011
// module chunks = 11